import React from "react";
import modalStyles from "./styles.module.css";
import DeleteSlot from "./DeleteSlot";
import { toast } from "react-toastify";

import { deleteAvailability } from "../../../../store/actions/availability";

const EditEventModal = ({
  setEditEventModal,
  selectedSlot,
  availability,
  setAvailability,
}) => {


  const handleClick = async () => {
    const data = await deleteAvailability(selectedSlot.id);
    if (data.success) {
      toast.success("Slot Deleted Successfully!");
      setAvailability((prev) => prev.filter((el) => el.id !== selectedSlot.id));
      setEditEventModal(false);
    } else {
      toast.error(data.message || "Failed to delete slot.");
    }
  };

  return (
    <div className={modalStyles.modalBackdrop}>
      <div className={modalStyles.modal}>
        {/* Header */}
        <div
          className={modalStyles.closeBtn}
          onClick={() => setEditEventModal(false)}
        >
          <i className="fas fa-close"></i>
        </div>
        <h2 className={modalStyles.modalHeading}>Manage Slot</h2>

        {/* Body */}
        <div className={modalStyles.slots}>
          <div className={modalStyles.slot}>
            <h4>Confirm Deletion</h4>
            <div className={modalStyles.summaryBox} style={{ background: 'linear-gradient(135deg, #fff5f5 0%, #fed7d7 100%)', borderColor: '#feb2b2' }}>
              <div className={modalStyles.summaryTitle} style={{ color: '#c53030' }}>
                <i className="fas fa-trash-alt"></i>
                Slot Details
              </div>
              <DeleteSlot slot={selectedSlot} />
            </div>
          </div>
        </div>

        <button
          className={modalStyles.saveSlotBtn}
          onClick={handleClick}
          style={{ background: 'linear-gradient(to right, #ef4444, #dc2626)', boxShadow: '0 4px 6px -1px rgba(220, 38, 38, 0.2)' }}
        >
          Confirm Delete
        </button>
      </div>
    </div>
  );
};

export default EditEventModal;
